import { Permissions } from "./permissions";

export class Role implements IRole{
    label: string;
    short_label: string;
    permissions: Permissions;
    id: number;

    public constructor(d: Role) {
        this.id = d.id;
        this.label = d.label
        this.short_label = d.short_label;
        this.permissions = new Permissions(d.permissions);
    }
}

export interface IRole {
    label: string;
    short_label: string;
    permissions: Permissions;
    id: number;
    
}

export enum AppRoles {
    WORKSPACE_ADMIN = 'admin',
    SUPER_ADMIN = 'spadmin',
    WORKSPACE_MEMBER = 'user',
    GUEST = 'guest'
}